export const validTypes = [
  'administrative_area_level_3',
  'locality',
  'sublocality_level_1',
  'neighborhood',
  'premise',
  'street_address',
  'route'
]

export const mxData = {
  name: 'mexico'
}
